import { ACTION_LOCATION_CATEGORY_LIST, ACTION_LOCATION_CATEGORY_SELECT, ACTION_LOCATION_CATEGORY_VIEW } from "../actions/locationCategories";
import { ACTION_REGION_LIST, ACTION_REGION_SELECT, ACTION_REGION_VIEW } from "../actions/regions";

let initialReducer = {
    locationCategories: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        },
        view: {
            name: '',
        },
        select: []
    },
    regions: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        },
        view: {
            name: '',
        },
        select: []
    },
}

let ConfigReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case ACTION_LOCATION_CATEGORY_LIST.type:
            return {
                ...state,
                locationCategories: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                    view: state.locationCategories.view,
                    select: state.locationCategories.select,
                }
            };
        case ACTION_LOCATION_CATEGORY_VIEW.type:
            return {
                ...state,
                locationCategories: {
                    list: state.locationCategories.list,
                    view: {
                        name: action.payload.name,
                    },
                    select: state.locationCategories.select,
                },
            };
        case ACTION_LOCATION_CATEGORY_SELECT.type:
            return {
                ...state,
                locationCategories: {
                    list: state.locationCategories.list,
                    view: state.locationCategories.view,
                    select: action.payload,
                },
            };
        case ACTION_REGION_LIST.type:
            return {
                ...state,
                regions: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                    view: state.regions.view,
                    select: state.regions.select,
                }
            };
        case ACTION_REGION_VIEW.type:
            return {
                ...state,
                regions: {
                    list: state.regions.list,
                    view: {
                        name: action.payload.name,
                    },
                    select: state.regions.select,
                },
            };
        case ACTION_REGION_SELECT.type:
            return {
                ...state,
                regions: {
                    list: state.regions.list,
                    view: state.regions.view,
                    select: action.payload,
                },
            };
        default:
            return state;
    }
}

export default ConfigReducers